var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5011 22.0001H4.67774C4.32733 21.9986 3.99 21.8624 3.73151 21.6181C3.47302 21.3737 3.31187 21.0388 3.27949 20.6784L2.20117 6.29907H16.9776L15.8993 20.6784C15.8669 21.0388 15.7058 21.3737 15.4473 21.6181C15.1888 21.8624 14.8515 21.9986 14.5011 22.0001V22.0001Z",
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58398 8.97913V19.3812",
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4482 8.99121L12.832 19.3688",
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7207 8.99121L6.33688 19.3688",
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9772 3.8269H2.02298C1.362 3.8269 0.826172 4.38029 0.826172 5.06292C0.826172 5.74555 1.362 6.29893 2.02298 6.29893H16.9772C17.6382 6.29893 18.174 5.74555 18.174 5.06292C18.174 4.38029 17.6382 3.8269 16.9772 3.8269Z",
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95372 1H12.049C12.3896 0.999985 12.7163 1.13884 12.9582 1.38636C13.2001 1.63387 13.3375 1.97002 13.3407 2.32168V3.82692H5.66211V2.32168C5.66523 1.97002 5.80269 1.63387 6.04458 1.38636C6.28646 1.13884 6.6132 0.999985 6.95372 1V1Z",
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumb);
export default __webpack_public_path__ + "static/media/Dumb.31c6c4dafb51f0c4860f7f6c23c90adc.svg";
export { ForwardRef as ReactComponent };